import React, { useEffect, useState, useRef } from 'react';
//import { Link, useNavigate } from "react-router-dom";
import { httpRequest, httpAuthHeaders } from '../../../../services/httpService';
import Modal from 'react-bootstrap/Modal';
// import Button from 'react-bootstrap/Button';
import Loader from '../../../parts/Loader';
//import InputText from '../elements/InputText';
import RenderErrors from '../../../elements/RenderErrors';
import InputTextArea from '../../../elements/InputTextArea';
import ButtonGroupSelection from '../../../elements/ButtonGroupSelection';
import store from '../../../../services/store';
import helpers from '../../../../services/helpers';
import { getApiData } from '../../../../services/apiService';
import ContactListModal from '../../../modals/ContactListModal';
import Swal from 'sweetalert2';
import { InputMask } from 'primereact/inputmask';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
 
export default function VehiclesFormModal ({
        reference_id = '', 
        is_show = false, 
        setShow, 
        handleSave, 
        header_title="Vehicle Information",
        src="customer",
        store_id="",
        index="",
        member_data={},
        direct_save,
        customer_id=''
    }){
    let default_data = {
        "id": "",
        "customer_id": "",
        "plate_number":"",
        "brand": "",
        "model_name": "",
        "year_model": null,
        "length": null,
        "width": null,
        "height": null,
        "weight": null,
        "driver": "",
    }
    const toast = useRef(null);
    const [loading, setLoading] = useState(0);
    const [notice, setNotice] = useState('');
    const [form_data, setFormData] = useState(default_data);
    const [form_loaded, setFormLoaded] = useState(0);
    const [errors, setErrors] = useState([]);

    const [customer_modal, setContactModal] = useState(0);
   
    useEffect(() => {
        setErrors([])
        
        // if(src=="store" && is_show) {
        //     fetchData()
        // }
        // else if(is_show && member_data) {
        //     setFormData(member_data)
        //     //fetchCities()
        // }
        // else{
        //     setFormData(default_data)
        //     //fetchCities()
        // }
        if(is_show && reference_id){
            fetchData()
        }
        else if(is_show){
            console.log({...default_data, 'customer_id': customer_id})
            setFormData(default_data)
            //console.log('reference_id', reference_id)
        }

        console.log('customer_id', customer_id)
    }, [is_show]);
   
    useEffect(() => {
        setErrors([])
    }, [form_data]);
    

    function fetchData(){
        if(!reference_id){
            return
        }
        const url = helpers.createShipBookingHubUrl(`vehicles/${reference_id}`)

        setLoading(1)
        httpRequest(url, "GET", {}, true)
        .then((res) => {
            setFormData(res)
            setLoading(0)
            setFormLoaded(1)
        })
        .catch((err) => {
            setLoading(0)
            setFormLoaded(0)

            Swal.fire({
                //title: err.message,
                text: err.message,
                icon: "error",
                confirmButtonText: "OK",
            })
            .then((result) => {
                if (result.isConfirmed) {
                    
                }
            })
        }); 
    }
    
    function inputChange(e) {
        let { value, name } = e.target;

        if (e.target.type === "checkbox") {
            value = 0;
            
            if (e.target.checked) value = 1;
        }

        let new_state = { [name]: value }

        setFormData({ ...form_data, ...new_state });
    }

    function validateForm(){
        let new_errors = {...errors}
        let variant_errors = 0;

        if(!form_data.name){
            new_errors['name'] = ['The name field is required.']
        }
        else{
            delete new_errors['name'];
        }

        if(!form_data.relationship){
            new_errors['relationship'] = ['The relationship field is required.']
        }
        else{
            delete new_errors['relationship'];
        }

        if(!form_data.gender){
            new_errors['gender'] = ['The gender field is required.']
        }
        else{
            delete new_errors['gender'];
        }

        console.log('age', form_data.age)
        if(form_data.age === null || form_data.age === undefined || form_data.age === ""){
            new_errors['age'] = ['The age field is required.']
        }
        else{
            delete new_errors['age'];
        }

        setErrors(new_errors);

        return new_errors;
    }

    // function handleSubmit(e) {
    //     // const validate = validateForm();
    //     // if(Object.keys(validate).length){
    //     //     toast.current.show({severity:'error', detail:'Please complete all required fields in the form.', life: 5000});
    //     //     return
    //     // }

    //     setShow(0);
    //     let form_data = {...form_data}
    //     if(reference_id){
    //         form_data.flag = 'edit'
    //     }

    //     handleSave(form_data, index)
        
    // }



    function handleSubmit(e) {

        // if(!form_data.category_name){
        //     setErrors(
        //         {"category_name":["The category name field is required."]}
        //     )
        //     return;
        // }
        
        //setLoading(1)

        let url = helpers.createShipBookingHubUrl('vehicles')
        if(reference_id && form_loaded){
            url = helpers.createShipBookingHubUrl(`vehicles/${reference_id}`)
        }

        //let form_data = {...form_data}

        console.log('form_data', form_data)
        console.log('url', url)

        httpRequest(url, 'POST', {
            postdata: form_data,
        }, true)
            .then((res) => {
                form_data.id = res.id
                setLoading(0)
                toast.current.show({severity:'success', detail:res.message, life: 20000});

                setShow(0);
                handleSave(form_data)
            })
            .catch((err) => {
                console.log(err)
                setLoading(0)
                
                if(err.data){
                    setErrors( err.data );
                }else{
                    setErrors([])
                }

                toast.current.show({severity:'error', detail:err.message, life: 5000});
            }); 
    }

    function handleClose(e) {
        reset();
        setShow(0);
    }

    function reset(){
        setFormData([])
        setNotice('')
    }

    const footerContent = (
        <div>
            <Button label="Save" className='rounded' icon="fas fa-check" onClick={(e) => handleSubmit(1)} autoFocus />
        </div>
    );

    function handleCustomer(e){
        let data = {...form_data}

        data.customer_id = e.id ?? ''
        data.customer_name = e.contact_name ?? ''
        setFormData(data)
    }

    return (
        <>
            <Toast ref={toast} position="top-center" />

            <ContactListModal is_show={customer_modal} setShow={setContactModal} handleSelect={handleCustomer} />

            <Dialog 
                visible={is_show} 
                position="top" 
                header={header_title} 
                style={{ width: '60vw' }} 
                breakpoints={{ 
                    '960px': '75vw', // On Tablet (screen < 960px), use 75% width
                    '641px': '95vw'  // On Mobile (screen < 641px), use 95% width
                }}
                onHide={handleClose} 
                footer={footerContent}
            >
                <Loader isLoading={loading}/>

                    <div className="row mt-2">
                        <div className="col-md-4">
                            <label>Customer/Owner<span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8 form-group">
                            <div className="p-inputgroup flex-1">
                                <InputText 
                                    placeholder="Select Customer"
                                    onClick={(e) => setContactModal(1)} 
                                    value={form_data.customer_name} 
                                    disabled={customer_id ? true : false}
                                />
                                <Button 
                                    icon="fas fa-search" 
                                    className="p-button-primary" 
                                    type="button"
                                    onClick={(e) => setContactModal(1)}
                                    disabled={customer_id ? true : false}
                                />
                            </div>
                            <RenderErrors 
                                errors={errors} 
                                name="customer_id" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label>Plate Number<span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8 form-group">
                            <InputText
                                id="plate_number" 
                                name="plate_number" 
                                value={form_data.plate_number}
                                tagClass="form-control mb-0"
                                placeholder="Plate Number"
                                onChange={inputChange}
                                className='w-100'
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="plate_number" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label>Brand<span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8 form-group">
                            <InputText
                                id="brand" 
                                name="brand" 
                                value={form_data.brand}
                                tagClass="form-control mb-0"
                                placeholder="Brand"
                                onChange={inputChange}
                                className='w-100'
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="brand" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label>Model<span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8 form-group">
                            <InputText
                                id="model_name" 
                                name="model_name" 
                                value={form_data.model_name}
                                tagClass="form-control mb-0"
                                placeholder="Model"
                                onChange={inputChange}
                                className='w-100'
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="model_name" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label>Driver<span className="text-danger"></span></label>
                        </div>
                        <div className="col-md-8 form-group">
                            <InputText
                                id="driver" 
                                name="driver" 
                                value={form_data.driver}
                                tagClass="form-control mb-0"
                                placeholder="Driver"
                                onChange={inputChange}
                                className='w-100'
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="driver" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label>Year Model<span className="text-danger"></span></label>
                        </div>
                        <div className="col-12 col-md-3 form-group">
                            <InputNumber
                                id="year_model" 
                                name="year_model" 
                                value={form_data.year_model}
                                tagClass="form-control mb-0"
                                placeholder="YYYY"
                                onValueChange={inputChange}
                                min={1970} 
                                max={2100} 
                                className='w-100'
                                useGrouping={false} 
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="year_model" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label>Lenght<span className="text-danger"></span></label>
                        </div>
                        <div className="col-12 col-md-3 form-group">
                            <InputNumber
                                id="length" 
                                name="length" 
                                value={form_data.length}
                                tagClass="form-control mb-0"
                                placeholder="Length"
                                onValueChange={inputChange}
                                min={0} 
                                max={999}
                                className='w-100'
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="length" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label>Width<span className="text-danger"></span></label>
                        </div>
                        <div className="col-12 col-md-3 form-group">
                            <InputNumber
                                id="width" 
                                name="width" 
                                value={form_data.width}
                                tagClass="form-control mb-0"
                                placeholder="Width"
                                onValueChange={inputChange}
                                min={0} 
                                max={999}
                                className='w-100'
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="width" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label>Height<span className="text-danger"></span></label>
                        </div>
                        <div className="col-12 col-md-3 form-group">
                            <InputNumber
                                id="height" 
                                name="height" 
                                value={form_data.height}
                                tagClass="form-control mb-0"
                                placeholder="Height"
                                onValueChange={inputChange}
                                min={0} 
                                max={999}
                                className='w-100'
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="height" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label>Weight<span className="text-danger"></span></label>
                        </div>
                        <div className="col-12 col-md-3 form-group">
                            <InputNumber
                                id="weight" 
                                name="weight" 
                                value={form_data.weight}
                                tagClass="form-control mb-0"
                                placeholder="Weight"
                                onValueChange={inputChange}
                                min={0} 
                                max={999}
                                className='w-100'
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="weight" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div>
                    {/* <div className="row">
                        <div className="col-md-4">
                            <label>Relationship<span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8 form-group">
                            <Dropdown  
                                name='relationship'
                                value={form_data.relationship} 
                                onChange={(e) =>
                                    setFormData(prev => ({
                                        ...prev,
                                        'relationship': e.value
                                    }))
                                } 
                                options={store.member_relationvehicles} 
                                optionLabel="label" 
                                optionValue="id" 
                                placeholder="Select Relationship" 
                                className="w-100" 
                                checkmark={true} 
                                highlightOnSelect={false}
                                filterInputAutoFocus={true}
                                appendTo="self"
                                showClear
                                filter 
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="relationship" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div> */}
            </Dialog>
        </>
    )
}